import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import ClickOutside from 'vuetify/lib/directives/click-outside';
import Ripple from 'vuetify/lib/directives/ripple';

import {
  VApp,
  VMain,
  VCard,
  VChip,
  VTooltip,
  VOverlay,
  VDatePicker,
  VList,
  VListGroup,
  VListItem,
  VListItemTitle,
  VAutocomplete,
  VMenu,
  VProgressCircular,
  VChipGroup,
  VTextField,
  VCardTitle,
  VCardText,
  VCardActions,
  VSpacer,
  VBtn,
  VSelect,
  VDivider,
  VDialog,
  VAlert,
  VDataTable,
  VPagination,
  VRadio,
  VRadioGroup,
  VTabs,
  VTab,
  VForm,
  VTabItem,
  VSkeletonLoader,
  VSwitch,
  VCalendar,
  VExpansionPanel,
  VExpansionPanels,
  VExpansionPanelHeader,
  VIcon,
  VExpansionPanelContent,
  VTimePicker,
  VListItemIcon,
  VAvatar,
  VTabsItems,
  VSheet,
  VFadeTransition,
  VFooter,
  VAppBar,
  VRow,
  VCol,
  VSlider,
  VContainer,
  VHover,
  VCheckbox,
  VTextarea,
  VCarousel,
  VCarouselItem,
  VFabTransition,
  VBottomSheet,
  VBadge,
  VLazy,
  VProgressLinear,
  VSubheader,
  VSimpleTable,
  VListItemContent,
  VSimpleCheckbox,
  VResponsive,
  VBtnToggle,
} from 'vuetify/lib';

Vue.use(Vuetify, {
  components: {
    VApp,
    VMain,
    VCard,
    VChip,
    VTooltip,
    VOverlay,
    VDatePicker,
    VList,
    VListGroup,
    VListItem,
    VListItemTitle,
    VAutocomplete,
    VMenu,
    VProgressCircular,
    VChipGroup,
    VTextField,
    VCardTitle,
    VCardText,
    VCardActions,
    VSpacer,
    VBtn,
    VSelect,
    VDivider,
    VDialog,
    VAlert,
    VDataTable,
    VPagination,
    VRadio,
    VRadioGroup,
    VTabs,
    VTab,
    VForm,
    VTabItem,
    VSkeletonLoader,
    VSwitch,
    VCalendar,
    VExpansionPanel,
    VExpansionPanels,
    VExpansionPanelHeader,
    VIcon,
    VExpansionPanelContent,
    VTimePicker,
    VListItemIcon,
    VAvatar,
    VTabsItems,
    VSheet,
    VFadeTransition,
    VFooter,
    VAppBar,
    VRow,
    VCol,
    VSlider,
    VCarousel,
    VCarouselItem,
    VFabTransition,
    VBottomSheet,
    VBadge,
    VLazy,
    VProgressLinear,
    VContainer,
    VHover,
    VCheckbox,
    VTextarea,
    VSubheader,
    VSimpleTable,
    VListItemContent,
    VSimpleCheckbox,
    VResponsive,
    VBtnToggle,
  },
  directives: {
    ClickOutside,
    Ripple,
  }
});

import preset from './default-preset/preset'
import pt from 'vuetify/es5/locale/pt';

export default new Vuetify({
  preset,
  icons: {
    iconfont: 'fa'
  },
  breakpoint: {
    mobileBreakpoint: 'sm',
    thresholds: {
      xs: 576,
      sm: 576,
      md: 768,
      lg: 992,
    },
  },
  lang: {
    locales: { pt },
    current: 'pt'
  },
  theme: {
    customProperties: true,
    variations: false,
  },
})
